import { rupiah } from 'lib/currency';
import { findColorType, findValidFor, formatTitleByWord } from 'lib/uiHelpers';
import { useNavigate } from 'react-router-dom';

const CardPlay = ({ item, onQuickView, onBuy }) => {
  const navigation = useNavigate();

  if (!item) {
    return (
      <div className="flex items-center justify-center py-4 text-gray-400 text-sm">No Data</div>
    );
  }

  const borderStyle = 'border-gray-200 hover:border-primary-main/80 hover:shadow-lg';
  const bgStyle = 'bg-white text-kin-text';

  const goToCheckout = (paramsId) => {
    navigation(`/checkout?package_type=event_package&package_id=${paramsId}`);
  };

  console.log('CardPlay item:', item);

  return (
    <div
      className={`group relative flex flex-col justify-between h-full 
      rounded-3xl border-2 ${borderStyle} ${bgStyle} 
      overflow-hidden cursor-pointer transition-all duration-300 
      px-6 py-8`}>
      {/* Tag Type */}
      <div
        className={`px-3 py-1.5 rounded-bl-2xl absolute top-0 right-0 ${findColorType(
          item?.type?.toLowerCase(),
        )}`}>
        <span className="text-sm font-semibold text-white capitalize">{item.type || '-'}</span>
      </div>

      {/* Title & Price */}
      <div className="flex flex-col gap-2 text-kin-text">
        <p className="font-light text-sm text-kin-text/80 uppercase">
          {item?.category === 1 ? 'Exhibition + Play' : 'Exhibition Only'}
        </p>

        <h3 className="capitalize text-lg font-bold text-kin-text leading-tight min-h-[60px] max-w-[300px] overflow-hidden line-clamp-2 break-words">
          {formatTitleByWord(item?.package_name || '-')}
        </h3>

        <p className="font-semibold text-base">{item.price ? rupiah(item.price) : 'Rp 0'}</p>
      </div>

      {/* Features */}
      <div className="bg-[#F3F2F0] p-3 rounded-lg mt-4">
        <ul className="flex flex-col gap-2 text-sm font-medium text-kin-text">
          <CardFeature icon="/kin/assest/image/icon-dollar.svg" label="One Time Payment" />

          <CardFeature
            icon="/kin/assest/image/icon-star.svg"
            label={`Valid for any ${findValidFor(item?.category)}`}
          />

          <CardFeature
            icon="/kin/assest/image/icon-calender.svg"
            label={`Valid on ${
              item.validity_period_month !== 0 ? `${item.validity_period_month} Month` : 'Everyday'
            }`}
          />

          <CardFeature
            icon="/kin/assest/image/icon-clock.svg"
            label={
              item?.credit_number > 0
                ? `${item.credit_number} Session${item.credit_number > 1 ? 's' : ''}`
                : `All Sessions`
            }
          />
        </ul>

        {/* Quick View (desktop only) */}
        {onQuickView && (
          <button
            onClick={() => onQuickView(item)}
            className="hidden md:block mt-2 text-sm font-semibold text-primary-main hover:underline">
            Quick View
          </button>
        )}
      </div>

      {/* CTA */}
      <div className="flex mt-4">
        <button
          onClick={() => goToCheckout(item.id)}
          className="bg-primary-main text-white rounded-full px-4 py-2
          text-xs font-semibold max-w text-center
          hover:bg-primary-dark transition-all duration-300">
          BUY NOW
        </button>
      </div>
    </div>
  );
};

/* Small clean subcomponent */
const CardFeature = ({ icon, label }) => (
  <li className="flex items-center gap-2">
    <img src={icon} alt="icon" className="w-4 h-4" />
    <span>{label}</span>
  </li>
);

export default CardPlay;
